import { useCompanyPrivacyConfig } from 'queries';
import useStore from './useStore';

// Privacy config (banner script + notice links) of the company whose side menu is selected.
// Nothing is shown until a menu is selected and that company has an active config.
// Callers must be wrapped with mobx `observer` to react to store changes.
function usePrivacyConfig() {
    const { subDashboardStore } = useStore();
    const { data: configs } = useCompanyPrivacyConfig();

    const selectedCompanyId = subDashboardStore.selectedCompanyId;
    if (!selectedCompanyId) {
        return undefined;
    }

    return configs?.find(config => config.sid === selectedCompanyId);
}

export default usePrivacyConfig;
